export default {
    member: {},
    role: 'consultant',
    notifications: [],
    preferences: {},
    integrations: []
}



// WEBPACK FOOTER //
// ./src/modules/profile/store/state.js